<template>
  <div id="retards">
    <Title :titlePage="titlePage" />
    <v-container fluid class="pa-4 pb-0">

      <div class="filter-bar">
        <v-text-field
          v-model="search"
          placeholder="Rechercher par raison sociale / numéro de commande"
          prepend-inner-icon="mdi-magnify"
          outlined
          dense
          hide-details
          clearable
          class="filter-search"
          @input="onSearchInput"
          @click:clear="onSearchClear"
        />
      </div>

      <resultList
        :header="headerRetards"
        :items="retards"
        :nbResult="displayItem"
        :type="'retards'"
        @sort="sort"
        :totalItems="totalItems"
        :page="page"
        height="calc(87vh - 175px)"
      />

      <div v-if="totalPages > 1" class="pagination-bar">
        <button class="page-btn" :disabled="page === 1" @click="page--">
          <v-icon small>mdi-chevron-left</v-icon>
        </button>
        <span class="page-info">Page {{ page }} / {{ totalPages }}</span>
        <button class="page-btn" :disabled="page === totalPages" @click="page++">
          <v-icon small>mdi-chevron-right</v-icon>
        </button>
      </div>

    </v-container>
  </div>
</template>

<script>
import Title from "@/components/shared/Title";
import ResultList from "@/components/shared/ResultList";
import moment from "moment";
import api from "@/api/retards.js";

export default {
  name: "Retards",
  components: { Title, ResultList },
  data() {
    return {
      titlePage: "Retards de Commandes",
      search: "",
      column: "numero_commande",
      order: "DESC",
      page: 1,
      totalItems: 0,
      totalPages: 0,
      displayItem: process.env.VUE_APP_NB_DISPLAY,
      retards: [],
      searchTimeout: null,
      headerRetards: [
        { text: "RAISON SOCIALE",     align: "center", sortable: true,  value: "raison_sociale" },
        { text: "NUMERO DE COMMANDE", align: "center", sortable: true,  value: "numero_commande" },
        { text: "NUMERO DE LIGNE",    align: "center", sortable: false, value: "numero_ligne" },
        { text: "MONTANT",            align: "center", sortable: true,  value: "montant", name: "montant" },
        { text: "LIVRAISON PRÉVUE",   align: "center", sortable: false, value: "date_prevue" },
        { text: "JOURS DE RETARD",    align: "center", sortable: false, value: "jours_retard" },
      ],
    };
  },
  watch: {
    page() {
      this.getRetards();
    },
  },
  methods: {
    getRetards() {
      const id = this.$store.state.AsUser.id_utilisateur || "";
      api.getRetards(id, this.column, this.order, this.page - 1, this.search).then((res) => {
        const today = moment().startOf("day");
        this.retards = res.data.retards.rows.map(r => {
          // Same rule as the API: confirmed date, or requested date when not confirmed
          const prevue = r.date_livraison_confirmee || r.date_livraison_demandee;
          return {
            ...r,
            raison_sociale: r.Commande ? r.Commande.raison_sociale : null,
            date_prevue: prevue ? moment(prevue).format("DD/MM/YYYY") : "",
            jours_retard: prevue ? today.diff(moment(prevue).startOf("day"), "days") : "",
          };
        });
        this.totalItems = res.data.retards.totalItems;
        this.totalPages = res.data.retards.totalPages;
      }).catch(() => {
        this.$store.dispatch('notify', { message: 'Erreur lors du chargement' });
      });
    },
    sort(sortEvent) {
      if (sortEvent.column !== undefined) {
        this.column = sortEvent.column;
        this.page = sortEvent.page;
      }
      if (sortEvent.order !== undefined) {
        this.order = sortEvent.order ? "ASC" : "DESC";
      }
      this.getRetards();
    },
    onSearchInput() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.page = 1;
        this.getRetards();
      }, 350);
    },
    onSearchClear() {
      this.search = "";
      this.page = 1;
      this.getRetards();
    },
  },
  created() {
    this.getRetards();
  },
};
</script>

<style scoped lang="scss">
#retards {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.filter-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.filter-search {
  max-width: 400px;
}

.pagination-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 6px 0 2px;
}

.page-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 1px solid #d0d0d0;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;

  &:hover:not(:disabled) {
    background: #f0f0f0;
    border-color: #0b87ba;
  }

  &:disabled {
    opacity: 0.35;
    cursor: default;
  }
}

.page-info {
  font-size: 0.82rem;
  color: #555;
  font-weight: 500;
  min-width: 90px;
  text-align: center;
}
</style>
